import React from "react";
import { Content } from "./Content";
import { ContentAndImage } from "./ContentAndImage";
import { ContentAndVideo } from "./ContentAndVideo";
import { Video } from "./Video";
import Spacer from "./Spacer";

function Component({ component }) {
  switch (component.fieldGroupName) {
    case "product_Productdata_Summary_Content":
      return <Content content={component.content} />;
    case "product_Productdata_Summary_ContentAndImage":
      return (
        <ContentAndImage
          content={component.content}
          image={component.image}
          placement={component.imagePlacement}
        />
      );
    case "product_Productdata_Summary_ContentAndVideo":
      return (
        <ContentAndVideo
          content={component.content}
          video={component.video}
          placement={component.videoPlacement}
          skinny
        />
      );
    case "product_Productdata_Summary_FullWidthVideo":
      return <Video video={component.video} />;
    default:
      return "";
  }
}

export const ProductOverview = ({ components }) => {
  return (
    <Spacer>
      {components
        ? components.map((component, index) => (
            <Spacer key={index}>
              <Component component={component} key={index} />
            </Spacer>
          ))
        : ``}
    </Spacer>
  );
};
